/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteDataSourceRequest } from '../../models/delete-data-source-request';

export interface DatasourcesDataSourceIdDelete$Params {
  dataSourceId: string;
      body?: DeleteDataSourceRequest
}

export function datasourcesDataSourceIdDelete(http: HttpClient, rootUrl: string, params: DatasourcesDataSourceIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, datasourcesDataSourceIdDelete.PATH, 'delete');
  if (params) {
    rb.path('dataSourceId', params.dataSourceId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

datasourcesDataSourceIdDelete.PATH = '/datasources/{dataSourceId}';
